import {createContext} from 'react';

export const ThreadListContext = createContext({});

export const ThreadListProvider = ThreadListContext.Provider;
